import nf from '@/constants/nf';
import { route } from '@/constants/routeName';
import ChildSelector from '@/components/Parent/ChildSelector';
import { Paid, Person } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

export default function UserHeader() {
	const user = useSelector((state) => state.auth.user);
	const selectedCustomer = useSelector((state) => state.auth.selectedCustomer);
	const selectedOutlet = useSelector((state) => state.auth.selectedOutlet);
	const children = useSelector((state) => state.auth.children) || [];
	const accountType = useSelector((state) => state.auth.accountType);

	const studentName = selectedCustomer?.member?.name;
	const studentClass = selectedCustomer?.member?.on_list_attributes?.class;
	const showSelector = accountType === 'parent' && children.length > 0;

	return (
		<div className='flex flex-col gap-2 bg-bz-default'>
			<div className='flex gap-2'>
				<div className='relative h-12 w-12 shrink-0 border border-black'>
					{user.avatar ? (
						<img src={user.avatar} alt={user.name} className='h-full w-full object-cover' />
					) : (
						<div className='flex h-full w-full text-[36px]'>
							<Person fontSize='inherit' className='m-auto' />
						</div>
					)}
				</div>
				<div className='flex min-w-0 flex-1 flex-col justify-center gap-0.5 py-0.5 text-sm'>
					<span className='font-bold text-black'>{user.name}</span>
					{studentName ? (
						<span className='truncate text-xs text-[var(--weak)]'>
							{studentName}
							{studentClass ? `, ${studentClass}` : ''}
							{selectedOutlet?.name ? ` · ${selectedOutlet.name}` : ''}
						</span>
					) : (
						<span className='text-xs text-[var(--weak)]'>
							{selectedOutlet?.name || (accountType === 'parent' ? 'No child selected' : '')}
						</span>
					)}
					{selectedCustomer && (
						<div className='flex items-center gap-3'>
							<span
								className={twMerge(
									'text-xs font-bold text-black',
									Math.sign(+selectedCustomer?.balance) < 0 ? 'text-red-500' : ''
								)}
							>
								Deposit: {nf(+selectedCustomer?.balance || 0)}
							</span>
							<Link
								to={`/${route.accountTopUp}`}
								className='inline-flex items-center gap-0.5 text-xs font-bold text-black underline underline-offset-2 transition-transform duration-100 active:scale-[0.98] active:opacity-80'
							>
								<Paid fontSize='small' /> Top up
							</Link>
						</div>
					)}
				</div>
			</div>
			{showSelector && (
				<div className='pt-0.5'>
					<ChildSelector />
				</div>
			)}
		</div>
	);
}
